import React, { useEffect, useRef, useState } from "react";
import { floatMessage } from "../../../Utils/floatMessage";
import styles from "./styles/KeepAlive.module.css";

function KeepAlive({ value, disabled, translation }) {
  const [showOptions, setShowOptions] = useState(false);
  const [selected, setSelected] = useState(1);
  const wrapperRef = useRef(null);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div
      disabled={disabled}
      onClick={() => setShowOptions(!showOptions)}
      ref={wrapperRef}
      className={styles.main}
    >
      <div className={styles.logo} />
      {value}
      {showOptions && (
        <div onClick={(e) => e.stopPropagation()} className={styles.options}>
          <div onClick={() => setSelected(1)} className={styles.option_cell}>
            {selected === 1 ? (
              <div className={styles.selected}></div>
            ) : (
              <div className={styles.no_selected}></div>
            )}
            Email
          </div>
          <div onClick={() => setSelected(1)} className={styles.option_cell}>
            {selected === 2 ? (
              <div className={styles.selected}></div>
            ) : (
              <div className={styles.no_selected}></div>
            )}
            {translation?.applicaton_notification_coming_soon}
          </div>
          <div onClick={() => setSelected(1)} className={styles.option_cell}>
            {selected === 3 ? (
              <div className={styles.selected}></div>
            ) : (
              <div className={styles.no_selected}></div>
            )}
            {translation?.sms_coming_soon}
          </div>
        </div>
      )}
    </div>
  );
}

export default KeepAlive;
